module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/page-not-found.component.scss
// module id = ./src/app/core/components/page-not-found.component.scss
// module chunks = main